// extracted by mini-css-extract-plugin
module.exports = {"container":"svg_container__y0A9C","gradient":"svg_gradient__CqYuR"};